import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
/**
 * 仓储管理
 */
const storageRouter: RouteRecordRaw[] = [
    {
        path: "warehouseManage",
        name: "WarehouseManage",
        meta: {
            title: "仓储监管"
        },
        children: [
            {
                path: "inventoryManagementQuery",
                name: "WarehouseManagementInventoryQuery",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inventoryQuery/index.vue"),
                meta: {
                    title: "库存查询",
                    isNotShowHeader: true,
                    keepAlive: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/storeInbound",
                name: "StoreInbound",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inboundManagement/index.vue"),
                meta: {
                    title: "入库管理",
                    keepAlive: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/storeInbound/detail",
                name: "StoreInboundDetail",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inboundManagement/detail.vue"),
                meta: {
                    title: "入库单详情",
                    activeMenu: "StoreInbound",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code
                }
            },
            {
                path: "/storeInbound/edit",
                name: "StoreInboundEdit",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inboundManagement/form.vue"),
                meta: {
                    title: "修改入库单",
                    activeMenu: "StoreInbound",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                }
            },
            {
                path: "/storeInbound/add",
                name: "StoreInboundAdd",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inboundManagement/form.vue"),
                meta: {
                    title: "新增入库单",
                    activeMenu: "StoreInbound",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                }
            },
            {
                path: "/storeOutbound",
                name: "StoreOutbound",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/outboundManagement/index.vue"),
                meta: {
                    title: "出库管理",
                    keepAlive: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/storeOutbound/detail",
                name: "StoreOutboundDetail",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/outboundManagement/detail.vue"),
                meta: {
                    title: "出库单详情",
                    activeMenu: "StoreOutbound",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code
                }
            },
            {
                path: "/storeOutbound/edit",
                name: "StoreOutboundEdit",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/outboundManagement/form.vue"),
                meta: {
                    title: "修改出库单",
                    activeMenu: "StoreOutbound",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                }
            },
            {
                path: "/storeOutbound/add",
                name: "StoreOutboundAdd",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/outboundManagement/form.vue"),
                meta: {
                    title: "新增出库单",
                    activeMenu: "StoreOutbound",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                }
            },
            {
                path: "/storeStocktaking",
                name: "StoreStocktaking",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/storeStocktakingManagement/index.vue"),
                meta: {
                    title: "盘点管理",
                    keepAlive: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/storeStocktaking/detail",
                name: "StoreStocktakingDetail",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/storeStocktakingManagement/detail.vue"),
                meta: {
                    title: "盘点详情",
                    activeMenu: "StoreStocktaking",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    hidden: true
                }
            },
            {
                path: "/storeRandomInspection",
                name: "StoreRandomInspection",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/inventoryRandomInspection/index.vue"),
                meta: {
                    title: "库存抽检",
                    pageType: PAGE_TYPE.LIST.code,
                    keepAlive: true
                }
            },
            {
                path: "/storeRandomInspection/detail/:id",
                name: "StoreRandomInspectionDetail",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/inventoryRandomInspection/detail.vue"),
                meta: {
                    title: "抽检详情",
                    activeMenu: "StoreRandomInspection",
                    hidden: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    isNotShowHeader: true
                }
            },
            {
                path: "storePledge",
                name: "StorePledgeManagement",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/pledgeManagement/index.vue"),
                meta: {
                    title: "质押记录",
                    pageType: PAGE_TYPE.LIST.code,
                    keepAlive: true
                }
            },
            {
                path: "storePledge/detail/:id",
                name: "StorePledgeDetail",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/pledgeManagement/detail.vue"),
                meta: {
                    title: "质押详情",
                    activeMenu: "StorePledgeManagement",
                    pageType: PAGE_TYPE.DETAIL.code,
                    hidden: true,
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default storageRouter;
